import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/edit/styles.scss';export default {
  "preview": "_preview_n1tx0_1",
  "footer": "_footer_n1tx0_13",
  "loader": "_loader_n1tx0_22",
  "closeButton": "_closeButton_n1tx0_37"
};